type CustomLocale = string;

const localeMap: Record<string, string> = {
  isl: 'is-IS',
  is:  'is-IS',
  en:  'en-US',
  'en-US': 'en-US',
  pl:  'pl-PL',
  'pl-PL': 'pl-PL',
};

function resolveLocale(loc?: string): string {
  if (!loc) return 'is-IS';
  return localeMap[loc] ?? loc; // if it's already a valid tag, use it; otherwise fallback handled below
}

export function formatDate(value: Date | string, customLocale?: CustomLocale): string {
  if (!value) return '';
  const date = new Date(value);
  const intlLocale = resolveLocale('is-IS');

  try {
    return new Intl.DateTimeFormat(intlLocale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  } catch {
    // absolute fallback to user's default locale if something unexpected is passed
    return new Intl.DateTimeFormat(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }
}
